import _ from 'lodash';
import {
  getTotalPrice,
  getProductFrontImageForNumber,
  mapDataWithLenghtsToDataWithColors,
  getProductForNumber,
} from '../../../selectors';
import { imageUrlForList } from '../../../utils/products';

const getListOfProducts = products => _.compact(_.flatten(_.keys(products)));

const createProduct = ({
  context,
  product,
  image,
  colorCode,
  deliveryDate,
  quantity,
  quantities,
  productCurrency,
  orderDiscount,
  sum,
  notes,
  season,
  customerId,
  collection,
}) => {
  return {
    collection,
    name: product.name,
    model: product.material,
    color: colorCode,
    deliveryDate: deliveryDate,
    amount: quantity,
    image,
    quantities,
    totals: {
      currency: productCurrency,
      quantitySum: quantity,
      totalWithoutRebate: sum,
      rebateAmount: sum * orderDiscount,
      sumWithRebate: sum * (1 - orderDiscount),
    },
    notes,
    context,
    number: product.number,
    season,
    customerId,
  };
};

const getQuantity = quantities => {
  return (
    _.reduce(Object.values(quantities), (sum, q) => {
      return sum + q;
    }) || 0
  );
};

export const getProductListForPricesEansCurrencyAndOrder = (
  context,
  currency,
  order,
) => {
  return getListOfProducts(order.products).map(productKey => {
    const orderProduct = order.products[productKey];
    const product = getProductForNumber(context)(orderProduct.number);
    const data = mapDataWithLenghtsToDataWithColors(orderProduct.data);

    return _.keys(data).map(colorCode => {
      const deliveryDate = orderProduct.deliveryDate
        ? orderProduct.deliveryDate
        : 'not set';

      const quantities = data[colorCode];

      const quantity = getQuantity(quantities);

      if (quantity === 0) {
        return null;
      }

      const { number, notes } = orderProduct;

      const orderDiscount = parseFloat(order.discount || 0) / 100.0;

      const totalObject = getTotalPrice(
        context,
        { doc: order },
        colorCode,
        number,
      );
      const image = getProductFrontImageForNumber(context)(number, colorCode);
      const imageWithFallback = _.get(image, 'front') || _.get(image, 'back');

      return createProduct({
        product: {
          number: product.n,
          name: product.name,
          notes: orderProduct.notes,
          material: product.mat,
        },
        colorCode,
        image: imageUrlForList(imageWithFallback),
        deliveryDate,
        quantity,
        quantities,
        orderDiscount,
        sum: totalObject.total,
        productCurrency: totalObject.currency,
        notes,
        context,
        season: orderProduct.season,
        customerId: order.customerId,
        collection: product.col,
      });
    });
  });
};
